import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './index';
import { Message } from "view-design";
Vue.use(VueRouter);

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  var token = sessionStorage.getItem('token');
  if (token) {
    next();
  } else {
    if (to.name == 'login') {
      next();
    } else {
      Message.warning("请先登录")
      router.replace("/")
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/router.js